import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/AuthSlice";
import casePaperReducer from "./slices/casePaperSlice";
import dashboardReducer from "./slices/dashboardSlice";
import dischargeSummaryReducer from "./slices/dischargeSummarySlice";
import drRoundReducer from "./slices/drRoundSlice";
import intakeOutputReducer from "./slices/intakeOutputSlice";
import medicalRecordReducer from "./slices/medicalRecordSlice";
import nursingNotesReducer from "./slices/nursingNotesSlice";
import otNoteReducer from "./slices/otNoteSlice";
import pathologyResultReducer from "./slices/pathologyResultSlice";
import purchaseOrderReducer from "./slices/purchaseOrderSlice";
import tprReducer from "./slices/tprSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    casePaper: casePaperReducer,
    dashboard: dashboardReducer,
    dischargeSummary: dischargeSummaryReducer,
    drRound: drRoundReducer,
    intakeOutput: intakeOutputReducer,
    medicalRecord: medicalRecordReducer,
    nursingNotes: nursingNotesReducer,
    otNote: otNoteReducer,
    pathologyResult: pathologyResultReducer,
    purchaseOrder: purchaseOrderReducer,
    tpr: tprReducer,
  },
});

export default store;
